import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('ARTICLE_COMMENTS_MODERATION').plugin(axiosPlugin, {template: "array"});

let fetchArticleCommentsModerationAction = redux.fetchActionGet();

export const fetchArticleCommentsModeration = (query = {}) => fetchArticleCommentsModerationAction(`/users/me/moderation-comments/articles?${queryString.stringify(query)}`);
export const resetArticleCommentsModeration = () => redux.actions.reset();

export const articleCommentsModeration = redux.reducer();